module.exports = __webpack_public_path__ + "static/img/grb.731a29f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grb.svg
// module id = 77
// module chunks = 1